import { Fragment, useState } from 'react'
import RichText from 'components/common/richText'
import UnderlineImage from 'images/Underline Illustration v2.png'
import { SwiperSlide } from 'swiper/react'
import { StyledH2, StyledH3 } from 'components/common/typography'
import LeftArrowIcon from 'images/Small Left Arrow.svg'
import RightArrowIcon from 'images/Small Right Arrow.svg'
import { ConditionalDiv } from 'components/common/common_styles'
import { ListWrapper, Title, Underline, Body, MobileSwiper, MobileTitleWrapper, LeftArrow, RightArrow } from './underlineList_styles'

const UnderlineList = ({ data, currentIndex, setCurrentIndex, small, raiseHeading }) => {
  const [swiper, setSwiper] = useState()

  const setIndex = index => () => {
    setCurrentIndex(index)
  }

  const onKeyDown = (event, index) => {
    // somewhat hacky workaround for keyboard accessibility
    if (event.key === 'Enter') {
      setCurrentIndex(index)
    }
  }

  return (
    <>
      <ConditionalDiv desktopOnly>
        <ListWrapper>
          {data.map((_data, index) =>
            <Fragment key={_data.title}>
              <Title onClick={setIndex(index)} onKeyDown={event => onKeyDown(event, index)} selected={index === currentIndex} tabIndex={0}>
                {raiseHeading ?
                  <StyledH2 variant={small ? 'h5' : 'h4'}>{_data.title}</StyledH2>
                  :
                  <StyledH3 variant={small ? 'h5' : 'h4'}>{_data.title}</StyledH3>
                }
                <Underline src={UnderlineImage} alt='' $visible={index === currentIndex} />
              </Title>
              <li>
                {index === currentIndex && _data.body &&
                  <Body>
                    {_data.body?.richText ?
                      <RichText data={_data.body} />
                      :
                      <>{_data.body}</>
                    }
                  </Body>
                }
              </li>
            </Fragment>
          )}
        </ListWrapper>
      </ConditionalDiv>
      <ConditionalDiv mobileOnly>
        <MobileSwiper
          onRealIndexChange={_swiper => setCurrentIndex(_swiper.realIndex)}
          onSwiper={_swiper => setSwiper(_swiper)}
        >
          {data.map(_data =>
            <SwiperSlide key={_data.title}>
              <MobileTitleWrapper>
                <Title as='div' selected>
                  {raiseHeading ?
                    <StyledH2 variant={small ? 'h5' : 'h4'}>{_data.title}</StyledH2>
                    :
                    <StyledH3 variant={small ? 'h5' : 'h4'}>{_data.title}</StyledH3>
                  }
                  <Underline src={UnderlineImage} alt='' />
                </Title>
              </MobileTitleWrapper>
              <Body>
                {_data.body?.richText ?
                  <RichText data={_data.body} />
                  :
                  <>{_data.body}</>
                }
              </Body>
            </SwiperSlide>
          )}
          <LeftArrow src={LeftArrowIcon} alt='left arrow' small={small} disabled={currentIndex === 0} onClick={() => swiper?.slidePrev()} />
          <RightArrow src={RightArrowIcon} alt='right arrow' small={small} disabled={currentIndex === data.length - 1} onClick={() => swiper?.slideNext()} />
        </MobileSwiper>
      </ConditionalDiv>
    </>
  )
}

export default UnderlineList
